// DynamicHeading.jsx
const DynamicHeading = ({ parts ,variant="black"}) => {
    return (
      <h1 className={`text-[32px] sm:text-[36px] md:text-[42px] lg:text-[48px] tracking-[-1px] md:tracking-[-1.5px] lg:tracking-[-2px] leading-[36px] sm:leading-[42px] md:leading-[46px] lg:leading-[50px] font-bold ${variant === "white" ? "text-white" : "text-black"}`}>
      {parts.map((part, index) =>
          part.highlight ? (
            <span key={index} className="text-jbsBlue">{part.text}</span>
          ) : part.lineBreak ? (
            <br key={index} />
          ) : (
            <span key={index}>{part.text} </span>
          )
        )}
      </h1>
    );
  };
  
  export default DynamicHeading;
  